module.exports = __webpack_public_path__ + "img/tree-09-a-leaves.2bdfc213.png";